import {reducer} from './helpers'
import {
  GET_GRF_QUALIFICATION_STATUS_FAILURE,
  GET_GRF_QUALIFICATION_STATUS_SUCCESS,
} from '../actions/groomRentsFree'

const initialState = {
  data: null,
  status: null,
}

export default reducer(initialState, (state, action) => {
  switch (action.type) {
    case GET_GRF_QUALIFICATION_STATUS_FAILURE:
      return {
        data: null,
        status: 'FAILURE',
      }
    case GET_GRF_QUALIFICATION_STATUS_SUCCESS:
      return {
        data: action.payload,
        status: 'SUCCESS',
      }
    default:
      return null
  }
})
